import styled from 'styled-components';
import { border, colorStyle, compose, display, layout, position, space } from 'styled-system';
import { getOmittableProps } from '../helpers/omit';
import { allText, flexItem } from '../helpers/styled';
import { radius, textStyle } from '../helpers/theme';

var isInstanceOfCustomBR = function isInstanceOfCustomBR(borderProp) {
  return borderProp !== null && borderProp !== undefined && borderProp.hasOwnProperty('square');
};

var decideBorderRadius = function decideBorderRadius(props) {
  var borderRadius = props.borderRadius,
      borderTopLeftRadius = props.borderTopLeftRadius,
      borderTopRightRadius = props.borderTopRightRadius,
      borderBottomRightRadius = props.borderBottomRightRadius,
      borderBottomLeftRadius = props.borderBottomLeftRadius;

  if (borderRadius && borderRadius === 'themed') {
    return "border-radius: ".concat(radius(8)(props), ";");
  } else if (isInstanceOfCustomBR(borderRadius)) {
    return "border-radius: ".concat(borderRadius[props.theme.shape], ";");
  }

  var borderRadiusStyles = '';

  if (isInstanceOfCustomBR(borderTopLeftRadius)) {
    borderRadiusStyles += "border-top-left-radius: ".concat(borderTopLeftRadius[props.theme.shape], ";");
  }

  if (isInstanceOfCustomBR(borderTopRightRadius)) {
    borderRadiusStyles += "border-top-right-radius: ".concat(borderTopRightRadius[props.theme.shape], ";");
  }

  if (isInstanceOfCustomBR(borderBottomRightRadius)) {
    borderRadiusStyles += "border-bottom-right-radius: ".concat(borderBottomRightRadius[props.theme.shape], ";");
  }

  if (isInstanceOfCustomBR(borderBottomLeftRadius)) {
    borderRadiusStyles += "border-bottom-left-radius: ".concat(borderBottomLeftRadius[props.theme.shape], ";");
  }

  return borderRadiusStyles;
};

var styleFn = compose(position, display, layout, space, colorStyle, allText, border, flexItem);
var styleProps = getOmittableProps(styleFn, 'textStyle');
export var Box = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: function shouldForwardProp(p) {
    return !styleProps.has(p);
  }
}).withConfig({
  displayName: "Box"
})(["box-sizing:border-box;", " ", " ", ""], styleFn, function (p) {
  return p.textStyle && textStyle(p.theme, p.textStyle);
}, decideBorderRadius);
export default Box;